export default {
  admin: 'admin',
  marketplace: 'marketplace',
  seller:  'seller',
  ecommerce: 'ecommerce',
  pudo: 'pudos',
  custom: 'custom',
  carrier: 'carrier',
  // Walmart
  contact_center: 'contact_center'
}